import store from "@frameworks/web/redux/store";
import { MARKET_NEWS_DATA, MARKET_NEWS_START_LOADER, MARKET_NEWS_STOP_LOADER, MARKET_NEWS_SET_ERROR, MARKET_NEWS_HIDE_ERROR, } from "../../interfaces/Home/iMarketNews";
class MarketNewsActions {
    constructor() {
        this.dispatch = store.dispatch;
    }
    getMarketNews(data) {
        this.dispatch({
            type: MARKET_NEWS_DATA,
            payload: { data },
        });
    }
    startLoader() {
        this.dispatch({
            type: MARKET_NEWS_START_LOADER,
        });
    }
    stopLoader() {
        this.dispatch({
            type: MARKET_NEWS_STOP_LOADER,
        });
    }
    setError(payload, errorType) {
        this.dispatch({
            type: MARKET_NEWS_SET_ERROR,
            payload: { errorData: payload },
        });
    }
    hideError(errorType) {
        this.dispatch({
            type: MARKET_NEWS_HIDE_ERROR,
        });
    }
}
export default MarketNewsActions;
